var FadeSupport                 = require("enyo-ui/FadeSupport"),
    HoverSupport                = require("enyo-ui/HoverSupport"),
    ScrollButton                = require("app/ui/ScrollButton"),
    ScrollerDecoratorScrollbars = require("enyo-ui/ScrollerDecoratorScrollbars"),
    icons                       = require("app/theme/icons"),
    kind                        = require("enyo/kind");

require("app/ui/ScrollerDecoratorScrollbars.less");

module.exports = kind(/** @lends  app.ui.ScrollerDecoratorScrollbars.prototype */ {

    /**
     * @private
     */
    name: "app.ui.ScrollerDecoratorScrollbars",

    /**
     * @private
     */
    kind: ScrollerDecoratorScrollbars,

    /**
     * @private
     */
    mixins: [
        HoverSupport
    ],

    /**
     * @private
     */
    classes: "app-ui-scroller-decorator-scrollbars",

    /**
     * The theme to use for this decorator.
     *
     * @type  {?string}
     * @public
     */
    theme: null,

    /**
     * Options for the vertical scrollbar.
     *
     * @type  {Object}
     * @public
     */
    scrollbarVerticalOptions: {
        mixins:         [FadeSupport],
        initialOpacity: 0
    },

    /**
     * Options for the horizontal scrollbar.
     *
     * @type  {Object}
     * @public
     */
    scrollbarHorizontalOptions: {
        mixins:         [FadeSupport],
        initialOpacity: 0
    },

    /**
     * Options for the scrollbar corner.
     *
     * @type  {Object}
     * @public
     */
    scrollbarCornerOptions: {
        mixins:         [FadeSupport],
        initialOpacity: 0
    },

    /**
     * The kind to use for scroll buttons.
     *
     * @type  {enyo.Control}
     * @public
     */
    scrollButtonKind: ScrollButton,

    /**
     * Options for the scroll button used to scroll up.
     *
     * @type  {Object}
     * @public
     */
    scrollButtonUpOptions: {
        tooltip: "Scroll up",
        icon:    icons["app.ui.ScrollerDecoratorScrollbars.scrollButtonUp"]
    },

    /**
     * Options for the scroll button used to scroll down.
     *
     * @type  {Object}
     * @public
     */
    scrollButtonDownOptions: {
        tooltip: "Scroll down",
        icon:    icons["app.ui.ScrollerDecoratorScrollbars.scrollButtonDown"]
    },

    /**
     * Options for the scroll button used to scroll to the left.
     *
     * @type  {Object}
     * @public
     */
    scrollButtonLeftOptions: {
        tooltip: "Scroll left",
        icon:    icons["app.ui.ScrollerDecoratorScrollbars.scrollButtonLeft"]
    },

    /**
     * Options for the scroll button used to scroll to the right.
     *
     * @type  {Object}
     * @public
     */
    scrollButtonRightOptions: {
        tooltip: "Scroll right",
        icon:    icons["app.ui.ScrollerDecoratorScrollbars.scrollButtonRight"]
    },

    /**
     * Options for the scroll thumb.
     *
     * @type {Object=}
     * @public
     */
    scrollThumbOptions: {
        minHeight: 30,
        minWidth:  30
    },

    /**
     * If true, chrome will show when scrolling, hide when not scrolling.
     *
     * @type  {boolean}
     * @public
     */
    fadeChromeOnScroll: false,

    /**
     * If true, chrome will show on hover, hide when not hovered.
     *
     * @type  {boolean}
     * @public
     */
    fadeChromeOnHover: false,

    /**
     * @private
     */
    observers: {
        toggleChromeFade: ["fadeChromeOnScroll", "fadeChromeOnHover"],
        fadeChrome:       ["scrolling", "hover"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.toggleChromeFade();
            this.themeChanged();
        };
    }),

    /**
     * Set theme classes based on current theme.
     *
     * @param  {string}  previousTheme  The previous theme
     * @private
     */
    themeChanged: function(previousTheme) {
        var currentTheme        = this.get("theme"),
            baseClass           = "app-ui-scroller-decorator-scrollbars",
            client              = this.$.client,
            scrollbarCorner     = this.$.scrollbarCorner,
            scrollbarVertical   = this.$.scrollbarVertical,
            scrollbarHorizontal = this.$.scrollbarHorizontal;

        if (previousTheme && previousTheme !== currentTheme) {
            this.removeClass(baseClass + "--" + previousTheme);
            client.removeClass(baseClass + "__client--" + previousTheme);
            scrollbarCorner.removeClass(baseClass + "__scrollbar-corner--" + previousTheme);
            scrollbarVertical.removeClass(baseClass + "__scrollbar-vertical--" + previousTheme);
            scrollbarHorizontal.removeClass(baseClass + "__scrollbar-horizontal--" + previousTheme);
        }

        if (currentTheme && currentTheme !== previousTheme) {
            this.addClass(baseClass + "--" + currentTheme);
            client.addClass(baseClass + "__client--" + currentTheme);
            scrollbarCorner.addClass(baseClass + "__scrollbar-corner--" + currentTheme);
            scrollbarVertical.addClass(baseClass + "__scrollbar-vertical--" + currentTheme);
            scrollbarHorizontal.addClass(baseClass + "__scrollbar-horizontal--" + currentTheme);
        }
    },

    /**
     * Snap scrollbar chrome to fully visible when fade is disabled.
     *
     * @private
     */
    toggleChromeFade: function() {
        var $scrollbarCorner     = this.$.scrollbarCorner || null,
            $scrollbarVertical   = this.$.scrollbarVertical || null,
            $scrollbarHorizontal = this.$.scrollbarHorizontal || null;

        if (!this.fadeChromeOnScroll && !this.fadeChromeOnHover) {
            $scrollbarCorner && $scrollbarCorner.fadeIn(true);
            $scrollbarVertical && $scrollbarVertical.fadeIn(true);
            $scrollbarHorizontal && $scrollbarHorizontal.fadeIn(true);
        }
    },

    /**
     * Toggles scrollThumb visibility based on scroll and/or hover state.
     *
     * @param  {boolean}  wasScrolling  The old value
     * @private
     */
    fadeChrome: function() {
        var $scrollbarCorner     = this.$.scrollbarCorner || null,
            $scrollbarVertical   = this.$.scrollbarVertical || null,
            $scrollbarHorizontal = this.$.scrollbarHorizontal || null;

        if (!this.fadeChromeOnScroll && !this.fadeChromeOnHover) {
            return;
        }

        if ((this.fadeChromeOnScroll && this.scrolling)
            || (this.fadeChromeOnHover && this.isHovered())
        ) {
            $scrollbarCorner && $scrollbarCorner.fadeIn();
            $scrollbarVertical && $scrollbarVertical.fadeIn();
            $scrollbarHorizontal && $scrollbarHorizontal.fadeIn();
        }
        else {
            $scrollbarCorner && $scrollbarCorner.fadeOut();
            $scrollbarVertical && $scrollbarVertical.fadeOut();
            $scrollbarHorizontal && $scrollbarHorizontal.fadeOut();
        }
    }

});
